import { motion } from "framer-motion";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import Contact from "../components/Contact";

const ScreenFive = () => {
  const fieldProps = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: false, amount: 0.2 },
  };
  const hoverRotate = {
    whileHover: { rotate: 4 },
    transition: { type: "spring", stiffness: 200, damping: 12 },
  };
  const shimmerProps = {
    initial: { rotateZ: 20, x: "-100%" },
    animate: { x: "100%" },
    transition: {
      repeat: Infinity,
      repeatType: "loop",
      duration: 0.6,
      repeatDelay: 3,
      ease: "linear",
    },
  };

  return (
    <section
      id="contact"
      className="bg-[#020046] py-20 min-h-screen px-4 sm:px-6 lg:px-12 flex flex-col items-center justify-center gap-8"
    >
      <div className="w-full flex flex-col lg:flex-row gap-8 lg:gap-12 items-center justify-center">
        <div className=" shadow-lg flex items-start justify-center flex-col w-full lg:w-[60%]">
          <div className="flex flex-col sm:flex-row gap-4 text-white mb-6 space-y-2 w-full">
            <motion.div
              {...fieldProps}
              transition={{ duration: 0.3, delay: 0.2 }}
              {...hoverRotate}
              className="relative inline-flex items-center justify-center overflow-hidden rounded-md bg-pink-600 px-6 py-3 font-medium text-neutral-200 w-full sm:w-auto cursor-pointer"
              onClick={() => (window.location.href = "tel:+911234567890")}
            >
              <span className="flex items-center gap-2 text-[#020046]">
                <FaPhoneAlt
                  className="p-2 rounded-full border-2 border-[#020046]"
                  size={40}
                />{" "}
                +91-1234567890
              </span>
              <motion.div
                className="absolute -top-4 inset-0 flex w-full h-[200px]  justify-center"
                {...shimmerProps}
              >
                <div className="relative h-full w-8 bg-white/20"></div>
              </motion.div>
            </motion.div>

            <motion.div
              {...fieldProps}
              transition={{ duration: 0.3, delay: 0.4 }}
              {...hoverRotate}
              className="relative inline-flex items-center justify-center overflow-hidden rounded-md bg-pink-600 p-4 max-h-16 font-medium text-neutral-200 w-full sm:w-auto cursor-pointer"
              onClick={() =>
                (window.location.href = "mailto:contact@clinic.com")
              }
            >
              <span className="flex items-center gap-2 text-[#020046]">
                <FaEnvelope
                  className="p-2 rounded-full border-2 border-[#020046]"
                  size={40}
                />{" "}
                contact@clinic.com
              </span>
              <motion.div
                className="absolute -top-4 inset-0 flex w-full h-[200px]  justify-center"
                {...{
                  ...shimmerProps,
                  transition: {
                    ...shimmerProps.transition,
                    delay: 0.35,
                  },
                }}
              >
                <div className="relative h-full w-8 bg-white/20"></div>
              </motion.div>
            </motion.div>
          </div>

          <iframe
            title="clinic-location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3558.06245259066!2d80.9444804!3d26.901512999999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3999571b9a241c27%3A0x19bb340cc800ca13!2sShree%20dham!5e0!3m2!1sen!2sin!4v1757874991362!5m2!1sen!2sin"
            referrerPolicy="no-referrer-when-downgrade"
            loading="lazy"
            className="w-full aspect-video rounded-xl"
          ></iframe>
        </div>

        <Contact />
      </div>
    </section>
  );
};

export default ScreenFive;
